import React, { useEffect, useState } from 'react';
import { Subscription } from 'apps/onboarding';
import { useRouterStore } from 'apps/hooks';

import { ChoosePlan } from './choosePlan';

export const CreateTeamFlow = () => {
  const routerStore = useRouterStore();

  const [planSelected, setPlanSelected] = useState(false);

  useEffect(() => {
    if (!routerStore.route.params.productType) {
      setPlanSelected(false);
    } else {
      setPlanSelected(true);
    }
  }, [routerStore.route.params.productType]);

  const handleClickCompanyForBusiness = () => {
    routerStore.navigate('home.newInitiative', {
      productType: 'business',
    });
    setPlanSelected(true);
  };

  const handleClickCompanyForTeam = () => {
    routerStore.navigate('home.newInitiative', {
      productType: 'pro',
    });
    setPlanSelected(true);
  };

  return (
    <div>
      {planSelected ? (
        <Subscription />
      ) : (
        <ChoosePlan
          onClickCompanyForBusiness={handleClickCompanyForBusiness}
          onClickCompanyForTeam={handleClickCompanyForTeam}
        />
      )}
    </div>
  );
};
